import { baseApi } from "./baseApi";

const LEG_BASE_URL = "/legs";

export const legApi = baseApi.injectEndpoints({
  tagTypes: ["Leg"],

  endpoints: (builder) => ({
    addLeg: builder.mutation({
      query: (payload) => ({
        url: LEG_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Leg", id: _id },
        { type: "Leg", id: "LIST" },
      ],
    }),

    listLeg: builder.query({
      query: (params) => ({
        url: LEG_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "Leg", id: _id })),
              { type: "Leg", id: "LIST" },
            ]
          : [{ type: "Leg", id: "LIST" }],
    }),

    getDDLLegList: builder.query({
      query: (params) => ({
        url: `${LEG_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "Leg", id: _id })),
              { type: "Leg", id: "DDL" },
            ]
          : [{ type: "Leg", id: "DDL" }],
    }),

    getLegDetail: builder.query({
      query: (id) => `${LEG_BASE_URL}/${id}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "Leg", id: _id },
        { type: "Leg", id: "LIST" },
      ],
    }),

    updateLeg: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${LEG_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "Leg", id },
        { type: "Leg", id: "LIST" },
      ],
    }),
     addLegNote: builder.mutation({
      query: ({ legId, ...body }) => ({
        url: `${LEG_BASE_URL}/${legId}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { legId }) => [
        { type: "Leg", id: legId },
        { type: "Leg", id: "LIST" },
      ],
    }),

    updateLegNote: builder.mutation({
      query: ({ legId, noteId, ...body }) => ({
        url: `${LEG_BASE_URL}/${legId}/notes/${noteId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { legId }) => [
        { type: "Leg", id: legId },
        { type: "Leg", id: "LIST" },
      ],
    }),

    listLegNotes: builder.query({
      query: ({ legId, page = 1, limit = 5 }) => ({
        url: `${LEG_BASE_URL}/${legId}/notes`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { legId }) => [
        { type: "Leg", id: legId },
        { type: "Leg", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useAddLegMutation,
  useListLegQuery,
  useLazyListLegQuery,
  useLazyGetDDLLegListQuery,
  useGetLegDetailQuery,
  useUpdateLegMutation,
  useAddLegNoteMutation,
  useUpdateLegNoteMutation,
  useLazyListLegNotesQuery,
} = legApi;
